<template>
	<div class="d-md-flex align-items-center justify-content-between mb-2 mt-2">
		<div>
			<h4 class="main-title mb-0">Roles</h4>
		</div>
	</div>
	<div class="row g-3 mb-2">
		<div class="col-xl-4" style="height: fit-content;">
			<form class="card card-one" @submit.prevent="submitForm()">
				<div class="card-header">
					<h6 class="card-title" v-if="status">New Role</h6>
					<h6 class="card-title" v-else>Update Role</h6>
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col-md-12">
							<label class="form-label">Role</label><span class="text-danger"> *</span>
							<input type="text" class="form-control" placeholder="Role"
								:class="{ 'is-invalid': errors?.role }" v-model="role.role" ref="role" />
							<span v-if="errors?.role" class="invalid-feedback">{{ errors?.role[0] }}</span>
						</div>
					</div>
				</div>
				<div class="card-footer text-end">
					<button type="button" class="btn btn-danger me-2" @click="discard()"><i
							class="ri-prohibited-line me-1"></i>Discard</button>
					<template v-if="status">
						<button type="submit" class="btn btn-primary">
							<span> <i class="ri-save-line me-1"></i> Submit</span>
						</button>
					</template>
					<template v-else>
						<button type="submit" class="btn btn-primary">
							<span> <i class="ri-save-line me-1"></i> Update </span>
						</button>
					</template>
				</div>
			</form>
		</div>
		<div class="col-xl-8">
			<div class="card card-one">
				<div class="card-header">
					<h6 class="card-title">Roles</h6>
				</div>
				<div class="card-body">
					<input type="text" class="form-control mb-2" id="search" placeholder="Search" v-model="meta.search"
						@keypress.enter="search()">
					<div class="table-responsive" style="overflow-y:scroll; height: 60vh;">
						<table class="table text-nowrap table-bordered table-hover table-bottom-border  mb-0">
							<thead>
								<tr style="background-color: #f5f5f5;">
									<th class="text-center">Sl No.</th>
									<th @click="sort('role')">
										Role
										<span>
											<i v-if="meta.keyword == 'role' && meta.order_by == 'asc'"
												class="ri-arrow-up-line"></i>
											<i v-else-if="meta.keyword == 'role' && meta.order_by == 'desc'"
												class="ri-arrow-down-line"></i>
											<i v-else class="fas fa-sort"></i>
										</span>
									</th>
									<th class="text-center">Status</th>
									<th class="text-center">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="roles.length == 0">
									<td colspan="4" class="text-center">No records found</td>
								</tr>
								<tr v-for="role, key in roles" :key="key">
									<td class="text-center">{{ meta.from + key }}</td>
									<td>{{ role.role }}</td>
									<td class="text-center">
										<div class="form-switch" v-can="roles.delete">
											<input class="form-check-input" type="checkbox" role="switch"
												:id="'role' + role.role_id" :checked="role.status" :value="role.status"
												@change="deleteRole(role)" />
											<label class="custom-control-label" :for="'role' + role.role_id"></label>
										</div>
									</td>
									<td class="text-center">
										<div v-can="roles.update">
											<a href="javascript:void(0)" class="text-primary me-2" v-if="role.status"
												@click="editRole(role)"><i class="ri-edit-line fs-18 lh-1"></i></a>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="card-footer">
					<Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page"
						@pagechanged="onPageChange" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
export default {
	components: {
		Pagination,
	},
	data() {
		return {
			meta: {
				search: "",
				order_by: "asc",
				keyword: "role_id",
				per_page: 10,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				to: 1,
				maxPage: 1,
				trashed: false,
			},
			role: {
				role_id: "",
				role: "",
			},
			roles: [],
			status: true,
			errors: [],
		};
	},
	mounted() {
		this.$refs.role.focus();
		this.index();
	},

	methods: {
		submitForm() {
			let vm = this;
			if (vm.status) {
				vm.create();
			} else {
				vm.update();
			}
		},
		index() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "paginateRoles", data: vm.meta })
				.then((response) => {
					vm.roles = response.data.data;
					vm.meta.totalRows = response.data.meta.total;
					vm.meta.lastPage = response.data.meta.last_page;
					vm.meta.from = response.data.meta.from;
					vm.meta.to = response.data.meta.to;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		create() {
			let vm = this;
			let loader = vm.$loading.show();
			vm.$store
				.dispatch("post", { uri: "addRole", data: vm.role })
				.then((response) => {
					loader.hide();
					vm.$store.dispatch("success", "Role Added successfully");
					vm.discard();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		update() {
			let vm = this;
			let loader = vm.$loading.show();
			vm.$store
				.dispatch("post", { uri: "updateRole", data: vm.role })
				.then((response) => {
					loader.hide();
					vm.$store.dispatch("success", "Role is successfully updated");
					vm.discard();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		editRole(role) {
			let vm = this;
			vm.$refs.role.focus();
			vm.errors = [];
			vm.status = false;
			vm.role = role;
		},

		deleteRole(role) {
			let vm = this;
			let loader = vm.$loading.show();
			role.status = role.status == 1 ? 0 : 1;
			vm.$store
				.dispatch("post", { uri: "deleteRole", data: role })
				.then(function (response) {
					loader.hide();
					vm.$store.dispatch("success", response.data.message);
					vm.discard();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		search() {
			let vm = this;
			vm.meta.page = 1;
			vm.index();
		},

		onPageChange(page) {
			let vm = this;
			vm.meta.page = page;
			vm.index();
		},
		sort(field) {
			let vm = this;
			vm.meta.keyword = field;
			vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
			vm.index();
		},
		discard() {
			let vm = this;
			vm.role.role = "";
			vm.$refs.role.focus();
			vm.errors = [];
			vm.status = true;
			vm.index();
		},
		onPerPageChange() {
			this.meta.page = 1;
			this.index();
		},
	},
};
</script>
<style scoped>
input:focus,
select:focus {
	outline: none;
	box-shadow: 0 0 0 0 transparent;
}
</style>